// src/pages/Cookies.tsx
import { motion } from 'framer-motion';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Separator } from '@/components/ui/separator';
import { ScrollArea } from '@/components/ui/scroll-area';

const Cookies = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      
      <main className="pt-32 pb-20">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="bg-white rounded-lg shadow-md p-8 border border-gray-100"
          >
            <h1 className="text-3xl font-bold text-stone-800 mb-6">Politika Piškotkov</h1>
            <Separator className="mb-6" />
            
            <ScrollArea className="h-[70vh] pr-4">
              <div className="space-y-6">
                <section>
                  <h2 className="text-xl font-semibold text-stone-800 mb-3">Kaj so piškotki?</h2>
                  <p className="text-stone-600 mb-3">
                    Piškotki so majhne besedilne datoteke, ki se ob obisku spletne strani shranijo na vaš računalnik, 
                    tablico ali mobilno napravo. Piškotki spletnim stranem omogočajo, da si zapomnijo vaše dejanja 
                    in nastavitve, kot so prijava, jezik, velikost pisave in druge nastavitve za prikaz, v določenem 
                    časovnem obdobju. To pomeni, da vam teh informacij ni treba ponovno vnašati ob vsakem ponovnem 
                    obisku strani ali ob prehodu z ene strani na drugo.
                  </p>
                </section>
                
                <section>
                  <h2 className="text-xl font-semibold text-stone-800 mb-3">Katere piškotke uporabljamo?</h2>
                  <p className="text-stone-600 mb-3">
                    Naša spletna stran uporablja različne vrste piškotkov za različne namene:
                  </p>
                  <ul className="list-disc pl-6 text-stone-600 space-y-2">
                    <li><span className="font-medium">Nujno potrebni piškotki:</span> Ti piškotki so potrebni za delovanje naše spletne strani in jih ni mogoče izklopiti v naših sistemih.</li>
                    <li><span className="font-medium">Funkcionalni piškotki:</span> Ti piškotki omogočajo izboljšane funkcionalnosti in personalizacijo, kot so videoposnetki in klepet v živo.</li>
                    <li><span className="font-medium">Analitični piškotki:</span> Ti piškotki nam omogočajo štetje obiskov in virov prometa, da lahko merimo in izboljšamo delovanje naše spletne strani.</li>
                    <li><span className="font-medium">Marketinški piškotki:</span> Ti piškotki se uporabljajo za sledenje obiskovalcem na naših spletnih straneh. Namen je prikazovanje oglasov, ki so relevantni in zanimivi za posameznega uporabnika.</li>
                  </ul>
                </section>
                
                <section>
                  <h2 className="text-xl font-semibold text-stone-800 mb-3">Kako upravljati piškotke?</h2>
                  <p className="text-stone-600 mb-3">
                    Večina spletnih brskalnikov omogoča določeno stopnjo nadzora nad večino piškotkov prek nastavitev brskalnika. 
                    Če želite omejiti ali blokirati vse piškotke, ki jih postavljajo naše ali katere koli druge spletne strani, 
                    lahko to storite prek nastavitev brskalnika. Upoštevajte, da lahko to vpliva na vašo izkušnjo brskanja, saj 
                    nekatere funkcije morda ne bodo delovale pravilno.
                  </p>
                  <p className="text-stone-600 mb-3">
                    Za več informacij o tem, kako upravljati s piškotki, obiščite spletno stran proizvajalca vašega brskalnika.
                  </p>
                </section>
                
                <section>
                  <h2 className="text-xl font-semibold text-stone-800 mb-3">Spremembe naše politike o piškotkih</h2>
                  <p className="text-stone-600 mb-3">
                    Vse spremembe naše politike o piškotkih bodo objavljene na tej strani. Če bodo spremembe pomembne, 
                    vas bomo o tem tudi posebej obvestili.
                  </p>
                </section>
                
                <section>
                  <h2 className="text-xl font-semibold text-stone-800 mb-3">Kontaktirajte nas</h2>
                  <p className="text-stone-600">
                    Če imate kakršna koli vprašanja glede naše politike o piškotkih, nas lahko kontaktirate na <a href="mailto:info@kamen.si" className="text-primary hover:underline">info@kamen.si</a>.
                  </p>
                </section>
                
                <p className="text-stone-500 text-sm italic mt-8">
                  Zadnja posodobitev: Januar 2025
                </p>
              </div>
            </ScrollArea>
          </motion.div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Cookies;